import {
  ACCESSIBILITY_ARGS,
  ANCHORED_ARGS,
  COMPONENT_STATE_ARGS,
  INPUT_MENU_ARGS,
  MENU_ARGS,
  MENU_PLACEMENT_ARG,
  Metadata,
  SIZING_ARGS,
  pick,
} from '../../../../../utils/spds/metadata';
import { ROLE_MENU, ROLE_MENUITEM } from '../../../../../utils/spds/constants/aria';
import { fn, hash } from '@ember/helper';
import Menu from '../../../menu/filterable.gjs';
import MenuItem from './menu-item.gjs';
import Super from '../../../core/menu/parent.gjs';

const METADATA = Metadata.define({
  description: 'Menu component for dropdown buttons',
  extends: [
    pick(ACCESSIBILITY_ARGS, ['ariaLabelledBy']),
    pick(COMPONENT_STATE_ARGS, ['open', { name: 'animated', default: true }, 'id']),
    pick(ANCHORED_ARGS, ['anchorElement', 'anchorOffset', MENU_PLACEMENT_ARG]),
    pick(MENU_ARGS, ['toggleOpenState']),
    pick(INPUT_MENU_ARGS, ['noResultsText', 'searchable', 'searchPlaceholder', 'searchThreshold']),
    pick(SIZING_ARGS, ['maxHeight', 'maxWidth', 'minWidth', 'width']),
  ],
  name: 'Dropdown Menu',
});

export default class SpdsActionButtonDropdownMenu extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  get animated() {
    return this.argOrDefault('animated');
  }

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @anchorOffset={{@anchorOffset}}
      @animated={{this.animated}}
      @ariaLabelledBy={{@ariaLabelledBy}}
      @id={{@id}}
      @items={{this.navigableOptions}}
      @maxHeight={{@maxHeight}}
      @maxWidth={{@maxWidth}}
      @minWidth={{@minWidth}}
      @noResultsText={{@noResultsText}}
      @open={{@open}}
      @placement={{@placement}}
      @role={{ROLE_MENU}}
      @searchable={{@searchable}}
      @searchPlaceholder={{@searchPlaceholder}}
      @searchThreshold={{@searchThreshold}}
      @width={{@width}}
      data-test-spds-action-button-dropdown-menu
      {{this.setupComponent}}
      {{this.validateArguments}}
    >
      <:body>
        {{yield
          (hash
            Item=(component
              MenuItem
              registerComponent=(fn this.registerItem false)
              role=ROLE_MENUITEM
              showSelectedStyles=false
              toggleOpenState=@toggleOpenState
              unregisterComponent=this.unregisterItem
            )
          )
        }}
      </:body>
    </Menu>
  </template>
}

export const ACTION_BUTTON_DROPDOWN_MENU_METADATA = SpdsActionButtonDropdownMenu.metadata;
